import React, {useEffect, useState} from "react";
import classes from "./DataValidation.module.css"
import {
    batchValidateCategory,
    findValidationResultDetails,
    getValidationProgressStatus,
    validateCategory
} from "../../../../../api/Category/category-service";
import {showError, showSuccess} from "../../../../../api/notification/ToastManager";
import {isLevel4ButtonDisabled} from "../../../../../api/MarketNode/marketNode-status";
import ValidationReport from "./Report/ValidationReport";
import LoadingSpinner from "./Spinner/LoadingSpinner";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import Aux from "../../../../../hoc/Auxiliary";
import {Divider} from 'primereact/divider';
import {StatusCode} from "../../../../../entities/StatusContext";
import {Tooltip} from 'primereact/tooltip';
import {getCoordinations} from "../../../../../api/Coordination/coordination-service";

const DataValidation = (props) => {
    const [filePath, setFilePath] = useState(props.categoryDetails['validationDTO'].filePath)
    const [validationWaiting, setValidationWaiting] = useState(props.categoryDetails['validationWaiting'])
    const [summary, setSummary] = useState(`${props.categoryDetails['validationDTO']['validationSummary']}`)
    const [btnStyle, setBtnStyle] = useState(`${classes.defaultButton}`);
    const [status, setStatus] = useState('');
    const [isPopupValidationDetailsVisible, setIsPopupValidationDetailsVisible] = useState(false)
    const [topicList, setTopicList] = useState([]);
    const [refreshIcon, setRefreshIcon] = useState("pi pi-sync");
    const [validationMsgStyle, setValidationMsgStyle] = useState(`${classes.blackText}`);
    const [validationResultContainWarnings, setValidationResultContainWarnings] = useState(false);
    const validLevel4Status = ["CROSS_VALIDATION_SUCCESSFUL_MARKET_NODE_STEPS", "COUNTERPARTY_VALIDATION_IN_PROGRESS", "AWAITING_FINAL_PUBLICATION", "COUNTERPARTY_VALIDATION_FAILED", "CROSS_VALIDATION_IN_PROGRESS_MARKET_NODE_STEPS", "AWAITING_COUNTERPARTY_VALIDATION", "SUBMISSION_COMPLETED_MARKET_NODE_STEPS", "SUBMISSION_COMPLETED_AND_PERSISTED_MARKET_NODE_STEPS"];
    const isValidLevel4MarketNode = (dcMarketNode) => {
        return validLevel4Status.some(
            (status) => dcMarketNode.marketNodeStatus.code === status
        );
    };

    const findMarketNodeReadyForLevel5Validation = (dcMarketNodeId, coordinationMatrices = []) => {
        return coordinationMatrices.reduce((result, coordinationMatrix) => {
            const {firstMarketNode, secondMarketNode} = coordinationMatrix;
            if (firstMarketNode?.id === dcMarketNodeId && isValidLevel4MarketNode(secondMarketNode)) {
                result.push(secondMarketNode);
            } else if (secondMarketNode?.id === dcMarketNodeId && isValidLevel4MarketNode(firstMarketNode)) {
                result.push(firstMarketNode);
            }
            return result;
        }, []);
    };



    useEffect(() => {
        getCoordinations(props.dcMarketNodeId).then(r => {
        var marketNodesReadyForCrossValidation = findMarketNodeReadyForLevel5Validation(
            props.dcMarketNodeId,
            r?.content || []
        );

        const res = props.categoryDetails['validationDTO'];
        setValidationWaiting(props.categoryDetails['validationWaiting'])
        setValidationMsgStyle(classes.blackText)
        const level3 = props.status.code === "VALIDATION_IN_PROGRESS" && props.status.context === "CATEGORY_STEPS" || props.status.code === "VALIDATION_SUCCESS" && props.status.context === "CATEGORY_STEPS" && !props.haveMultipleCategories && marketNodesReadyForCrossValidation.length > 0;
        props.setLoading(level3 || props.statusLV4)
        props.setLoadingLevel3(level3)
        if (res.status.code !== props.status.code) {
            props.setStatus(res.status)
        }
        if (res.status.code !== "VALIDATION_IN_PROGRESS") {
            props.onFileUpload(false);
            props.setUploadBtnDisabled(false);
        }
        if ((res.status.code === "VALIDATION_SUCCESS" && props.haveMultipleCategories) ||
            (res.status.code === "VALIDATION_SUCCESS" && res.status.context === "LEVEL4_STEPS" && !props.haveMultipleCategories)||
           (res.status.code === "VALIDATION_SUCCESS" && res.status.context === "CATEGORY_STEPS" && marketNodesReadyForCrossValidation.length === 0)) {
            setBtnStyle(classes.downloadBtnSuccess)
            setStatus("_ACCEPTED")
        }
        if (res.status.code === "VALIDATION_FAILED") {
            setBtnStyle(classes.downloadBtnFailed)
            setStatus("_REJECTED")
        }
        if (res.status.code === StatusCode.FILES_SKIPPED) {
            props.setValidationMsg("No data to be provided")
            setValidationMsgStyle(classes.blackText)
        }
        setSummary(res['validationSummary']);
        setValidationResultContainWarnings(res['containWarnings']);
        setFilePath(res.filePath);
        }); }, [props.status, props.statusLV4])

    const updateLevel4Button = (validationResult) => {
        const categories = props.categoriesProps
            .map(e => e['validationDTO'])
            .filter(j => j.id !== validationResult.id);
        categories.push(validationResult)
        props.setValidationButtonDisabled(isLevel4ButtonDisabled(categories))
    }

    useEffect(() => {
        if (props.uploadFinished) {
            runValidation().then(() => props.setUploadFinished(false));
        }
    }, [props.uploadFinished]);

    const runValidation = async () => {
        props.setLoading(true);
        props.setLoadingLevel3(true);
        var data = {
            "uploadMethod": props.categoryDetails.categoryDTO.uploadMethod.name,
            "modelPath": props.modelPath,
            "categoryName": props.categoryDetails['categoryDTO'].name,
            "dataCollection": props.dataCollection,
            "marketNode": props.marketNode,
            "validationId": props.categoryDetails['validationDTO'].id,
            "sheetsName": props.categoryDetails['categoryDTO'].topics.map(s => s.name),
            "excelFilePath": props.filePath
        };
        const validateFn = props.haveMultipleCategories
            ? validateCategory
            : batchValidateCategory;
        return await validateFn(data).finally((res) => {
            props.setLoading(false);
            props.setLoadingLevel3(false);
            props.onFileUpload(false);
            props.setUploadBtnDisabled(false);
        });

    }


    const showValidationSuccess = (res) => {
        updateLevel4Button(res.content)
        setFilePath(res.content.filePath);
        setSummary(res.content['validationSummary']);
        setValidationResultContainWarnings(res.content['containWarnings']);
        props.setStatus(res.content.status);
        showSuccess("Success", `Validation is completed.`);
    }
    const headerTitle = "Validation details for " + props.marketNode.name + " - " + props.categoryDetails['categoryDTO'].name;
    const footer = () => {
        return (
            <>
                <div className={classes.flexDisplay}>
                    <div className={`col flex align-items-center justify-content-end m-0 p-0`}
                         style={{height: "2.5em"}}>
                        <Button
                            icon={refreshIcon}
                            onClick={getValidationStatus}
                            text
                            style={{color: '#487c84', width: "2.7em"}}
                        />
                    </div>
                </div>
            </>
        )
    }
    const showValidationFailed = async () => {
        setFilePath(null);
        await findValidationResultDetails(props.validationResut.id)
            .then(res => {
                if (res.status === 200) {
                    updateLevel4Button(res.content)
                    props.setStatus(res.content.status)
                } else {
                    showError('Error', "A problem was occurred when searching category status")
                }
            })
    }

    const getValidationProgressColor = (status) => {
        if (status === "SUCCESS") {
            return "#3f9c35";
        }
        if (status === "IN_PROGRESS") {
            return "orange";
        }
        if (status === "FAILED") {
            return "red";
        }
        if (status === "NOT_YET_STARTED") {
            return "grey";
        }
        if (status === "SHEET_NOT_FOUND") {
            return "red";
        }
    }

    function showValidationDetails() {
        getValidationStatus();
        setIsPopupValidationDetailsVisible(true);

    }

    function hidePopup() {
        setIsPopupValidationDetailsVisible(false);
    }


    function getValidationStatus() {
        setRefreshIcon("pi pi-spin pi-sync")
        getValidationProgressStatus(props.dataCollection.name, props.categoryDetails['categoryDTO'].name, props.marketNode.name).then(r => {
            if (r.content != null) {
                setTopicList(r.content);
            } else {
                showError("Error", `An error occurs when getting the validation status.`);
            }
            setRefreshIcon("pi pi-sync")
        });
    }

    if (props.technicalIssue && (!props.loading || !props.loadingLevel3)) {
        return (
            <div className="flex align-items-center justify-content-center" style={{height: "7.5em"}}>
                <b>Technical issue</b>
            </div>
        );
    }
    return (
        <div className="flex align-items-center justify-content-center">
            <div className="grid">

                <div className="col-12 flex align-items-center justify-content-center">
                    <span>
                    <label className={classes.title}>Data validation</label>

                        {validationWaiting ?
                            <><Tooltip target=".disabled-button"/>
                                <span className="disabled-button" data-pr-tooltip="Server busy, please wait">
                            <Button icon="pi pi-info-circle"
                                    visible={props.loadingLevel3}
                                    className={classes.iconButton + " p-button-rounded-sm p-button-text"}
                                    size="small"
                                    disabled
                                    style={{color: "#487c84"}}
                            /> </span></> : <Button icon="pi pi-external-link"
                                                    visible={props.loadingLevel3 && props.uploadMethod !== "zip-xml"}
                                                    tooltip="Consult validation details"
                                                    className={classes.iconButton + " p-button-rounded-sm p-button-text"}
                                                    onClick={showValidationDetails}
                                                    size="small"
                                                    style={{color: "#487c84"}}
                            />}
                </span>
                </div>
                <div className="col-12 flex align-items-center justify-content-center">
                    {props.loading
                        ? <LoadingSpinner validationId={props.categoryDetails.id}
                                          crossValidationMsg={props.crossValidationMsg}
                                          onFileUpload={props.onFileUpload}
                                          setUploadBtnDisabled={props.setUploadBtnDisabled}
                                          dc={props.dataCollection}
                                          mn={props.marketNode}
                                          setLoading={p => props.setLoading(p)}
                                          setLoadingLevel3={props.setLoadingLevel3}
                                          setFilePath={p => setFilePath(p)}
                                          setSummary={s => setSummary(s)}
                                          setValidationResultContainWarnings={s => setValidationResultContainWarnings(s)}
                                          statusLevel4={props.statusLV4}
                                          setStatus={s => setStatus(s)}/>
                        : <ValidationReport filePath={filePath}
                                            btnStyle={btnStyle}
                                            status={status}
                                            summary={summary}
                                            validationResultContainWarnings={validationResultContainWarnings}
                                            validationMsgStyle={validationMsgStyle}
                                            validationMsg={props.validationMsg}
                                            categoryId={props.categoryDetails.categoryDTO.id}
                                            marketNode={props.marketNode}
                                            uploadMethod={props.uploadMethod}
                        />}
                </div>
            </div>
            <Dialog header={headerTitle} footer={footer()} visible={isPopupValidationDetailsVisible} onHide={hidePopup}
                    modal
                    style={{width: '50vw'}}>
                <div className={classes.flexDisplay} style={{backgroundColor: "#D8E2E5"}}>
                    <div className={`col-5 flex align-items-center justify-content-left m-0 p-0`}
                         style={{height: "2.5em"}}>
                        <h3 className={classes.firstCol}>Topic</h3>
                    </div>
                    <div className={`col flex align-items-center justify-content-center m-0 p-0`}
                         style={{height: "2.5em"}}>
                        <h3>Extraction</h3>
                    </div>
                    <div className={`col flex align-items-center justify-content-center m-0 p-0`}
                         style={{height: "2.5em"}}>
                        <h3>Validation</h3>
                    </div>
                    <div className={`col-3 flex align-items-center justify-content-center m-0 p-0`}
                         style={{height: "2.5em"}}>
                        <h3>Result</h3>
                    </div>
                </div>
                <div>
                    {topicList.map((x) => (
                        <Aux key={x.sheetsName}>
                            <div className={classes.flexDisplay}>
                                <div className={`col-5 flex align-items-center justify-content-left m-0 p-0`}
                                     style={{height: "2.5em"}}>
                                    <h4 className={classes.firstCol}> {x.topicName}</h4>
                                </div>
                                <div className={`col flex align-items-center justify-content-center m-0 p-0`}
                                     style={{height: "2.5em"}}>
                                <span>
                      <i className="pi pi-circle-fill"
                         style={{'fontSize': '.8em', 'color': getValidationProgressColor(x.extractionStatus)}}></i>

                  </span></div>
                                <div className={`col flex align-items-center justify-content-center m-0 p-0`}
                                     style={{height: "2.5em"}}>
                                <span>
                      <i className="pi pi-circle-fill"
                         style={{'fontSize': '.8em', 'color': getValidationProgressColor(x.validationStatus)}}></i>

                  </span>
                                </div>
                                <div
                                    className={`col-3 flex align-items-center justify-content-center border-round m-0 p-0`}
                                    style={{height: "2.5em"}}>
                                    <h4>{x.validationStatus === "SHEET_NOT_FOUND" ? "❌ Sheet not found" : x.nbError + " Error(s)"}</h4>
                                </div>
                            </div>
                            <Divider style={{height: "0.01em", margin: "0"}}/>
                        </Aux>
                    ))
                    }
                </div>
            </Dialog>

        </div>

    )
}

export default DataValidation;
